import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
// import { SavedProductInterface } from '@app/interface/savedproduct';
import { SubscriptionInterface } from '@app/interface/subscription';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionApiService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient // private cookieService: CookieService
  ) {
    super(auth, httpClient);
  }

  // using getRecursivePage
  public getAllSubscriptions<T = SubscriptionInterface>(
    organization_id: number | null,
    params: httpQueryParams = {}
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/subscription/`;
    return this.getRecursivePage<T>(path, params);
  }

  public createSubscription(
    organization_id: number,
    service: Partial<SubscriptionInterface>
  ): Observable<SubscriptionInterface> {
    const path = `api/${organization_id}/subscription/`;
    return this.post<SubscriptionInterface>(path, {}, service);
  }

  public updateSubscriptionDetails(
    organization_id: number | null,
    id: number,
    data: Partial<SubscriptionInterface>
  ): Observable<SubscriptionInterface> {
    return this.partialUpdate<SubscriptionInterface>(
      `api/${organization_id}/subscription/${id}/`,
      {}, //{ withCredentials: true },
      data
    );
  }
}
